const showMoreParam = {
	count: 1
}

function showMore() {
	const list = document.querySelector('.works-designers__list')
	const item = list.querySelectorAll('.item-works-designers')
	let itemShow = showMoreParam.count * 4

	for (let i = 0; i < itemShow; i++) {
		if (item[i]) item[i].style = 'display: flex'
		else this.remove()
	}

	showMoreParam.count++
}
